import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import {
  Badge,
  Box,
  Divider,
  Flex,
  Heading,
  HStack,
  VStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import { capitalizeTitle } from 'utils/StringUtils';
import { essay_schema } from './data/essay_schema';

function Assessment({ breadcrumbProg, setBreadcrumbProg }) {
  // console.log('-----------------entering assessment page');
  // console.log('return url: ', returnUrl); // todo: add back button

  const { essayId } = useParams();
  const [title, setTitle] = useState('');
  const [essay, setEssay] = useState('');
  const [assessment, setAssessment] = useState({});

  const exerciseDetails = {
    ...essay_schema,
    ...JSON.parse(localStorage.getItem('essayExerciseDetails')),
  };

  function updateStateData(details) {
    setTitle(details.title);
    setEssay(details.essayText);
    setAssessment(details.assessment);
  }

  useEffect(() => {
    setBreadcrumbProg(breadcrumbProg);
  }, [setBreadcrumbProg, breadcrumbProg]);

  useEffect(() => {
    if (exerciseDetails?.essayId == essayId) {
      updateStateData(exerciseDetails);
    }

    if (
      exerciseDetails?.essayId != essayId ||
      (exerciseDetails?.progress >= 6 &&
        !exerciseDetails?.assessment?.overallComment)
    ) {
      api
        .get(`${API_BASE}/api/essay-exercise/retrieve-data?exerciseId=${essayId}`)
        .then((res) => {
          // console.log('============= assessment fetch response: ', res);
          if (res.status == 200) {
            const newEssayData = res.data?.data;
            updateStateData(newEssayData);
            localStorage.setItem(
              'essayExerciseDetails',
              JSON.stringify(newEssayData)
            );
          }
        })
        .catch(() =>
          console.log('failed to fetch exercise assessment data, id: ', essayId)
        );
    }
  }, []);

  function getEssayParagraphs() {
    if (!essay) return [];
    const essayParagraphs = essay
      .split('\n')
      .filter((paragraph) => paragraph.trim() !== '');
    return essayParagraphs;
  }

  return (
    <>
      <Flex direction="column">
        <Box
          maxW="1000px"
          minW="360px"
          mx="auto"
          p="4"
          bg="white"
          shadow="lg"
          borderRadius="lg"
          mb="32px"
        >
          <Heading size="md" textAlign="center" w="100%">
            {capitalizeTitle(title)}
          </Heading>
          <Divider mb="8px" mt="8px" />
          {/* <Text
            // noOfLines={isExpanded ? null : 3}
            display="inline"
            dangerouslySetInnerHTML={{ __html: essay }}
          /> */}
          {getEssayParagraphs().map((paragraph, index) => (
            <Text fontSize="md" color="gray.700" mb={1} key={index}>
              {paragraph}
            </Text>
          ))}
        </Box>
        <Flex>
          <Box
            maxW="1000px"
            mx="auto"
            p="4"
            bg="white"
            shadow="lg"
            borderRadius="lg"
            mb="48px"
          >
            {/* Overall Comment and Score */}
            <VStack spacing={2} align="start">
              <Heading size="md" textAlign="center" w="100%">
                Overall Feedback
              </Heading>
              <Text fontSize="md" color="gray.600">
                {assessment?.overallComment}
              </Text>
              <HStack>
                <Text fontSize="md" fontWeight="bold">
                  Overall Score:
                </Text>
                <Badge colorScheme="blue" fontSize="md">
                  {assessment?.overallScore}/100
                </Badge>
              </HStack>

              <Divider />

              {/* Specific Assessments */}
              {assessment?.assessmentAreas?.map((area, index) => (
                <Box
                  key={index}
                  bg="gray.100"
                  p={4}
                  borderRadius="md"
                  w="100%"
                  mb={2}
                  shadow="sm"
                >
                  <Heading size="md" mb={2} color="teal.700">
                    {area.aspect}
                  </Heading>
                  <Stack direction="row" align="center" mb={3}>
                    <Text fontWeight="bold">Score:</Text>
                    <Badge colorScheme="green" fontSize="md">
                      {area.score}/100
                    </Badge>
                  </Stack>
                  <Text mb={2}>
                    <strong>Strengths:</strong> {area.strengths}
                  </Text>
                  <Text>
                    <strong>Areas for Improvement:</strong> {area.improvements}
                  </Text>
                </Box>
              ))}

              <Divider />

              {/* Suggestions Section */}
              <Box
                bg="green.50"
                p={4}
                borderLeft="5px solid #28a745"
                borderRadius="md"
                w="100%"
              >
                <Heading size="md" color="green.600" mb={2}>
                  Suggestions for Improvement
                </Heading>
                <Text color="gray.600">{assessment?.suggestions}</Text>
              </Box>
            </VStack>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}

Assessment.propTypes = {
  breadcrumbProg: PropTypes.number,
  setBreadcrumbProg: PropTypes.func,
  // nextPath: PropTypes.string,
  // returnUrl: PropTypes.string,
};

export default Assessment;
